"use client"

import { useTranslations } from "next-intl"

import { Button, Text } from "@/components/ui"

interface DidYouMeanProps {
  suggestion: string
  onSelect?: (term: string) => void
}

export const DidYouMean = ({ suggestion, onSelect }: DidYouMeanProps) => {
  const t = useTranslations("search")
  return (
    <Text as="div" variant="bodySm" tone="subtle" className="bg-surface-newgray rounded-8x px-400 py-300">
      {t.rich("didYouMean.prompt", {
        suggestion,
        btn: (chunks) => (
          <Button variant="quiet" onClick={() => onSelect?.(suggestion)} className="text-fg-brand font-bold underline">
            {chunks}
          </Button>
        ),
      })}
    </Text>
  )
}
